import { __assign, __awaiter, __generator } from "tslib";
import { TicketPriority, ItemType } from '../domain';
import { createMultiLingualCustomFieldsApi, createMultilevelCustomFieldsApi } from '../custom-fields';
import { createFilesApi } from '../files';
export var SearchResultType;
(function (SearchResultType) {
    SearchResultType[SearchResultType["PAGINATED"] = 1] = "PAGINATED";
    SearchResultType[SearchResultType["OFFSET"] = 2] = "OFFSET";
})(SearchResultType || (SearchResultType = {}));
export var SavedFilterContext;
(function (SavedFilterContext) {
    SavedFilterContext[SavedFilterContext["TICKET_FILTER"] = 0] = "TICKET_FILTER";
    SavedFilterContext[SavedFilterContext["CHAT_FILTER"] = 10] = "CHAT_FILTER";
})(SavedFilterContext || (SavedFilterContext = {}));
export var PRESENCE_TTL = 2; // minutes (older presence info is removed)
export var ChatTransferType;
(function (ChatTransferType) {
    ChatTransferType[ChatTransferType["ONLINE"] = 0] = "ONLINE";
    ChatTransferType[ChatTransferType["OFFLINE"] = 1] = "OFFLINE";
})(ChatTransferType || (ChatTransferType = {}));
export var ChatTransferClass;
(function (ChatTransferClass) {
    ChatTransferClass[ChatTransferClass["COLD"] = 0] = "COLD";
    ChatTransferClass[ChatTransferClass["WARM"] = 1] = "WARM";
})(ChatTransferClass || (ChatTransferClass = {}));
export var FacebookReplyErrorCodes;
(function (FacebookReplyErrorCodes) {
    FacebookReplyErrorCodes[FacebookReplyErrorCodes["POST_DELETED"] = -230000] = "POST_DELETED";
})(FacebookReplyErrorCodes || (FacebookReplyErrorCodes = {}));
export var TicketEscalationErrorCode;
(function (TicketEscalationErrorCode) {
    TicketEscalationErrorCode[TicketEscalationErrorCode["ESCALATION_TARGET_UNAVAILABLE"] = -400100] = "ESCALATION_TARGET_UNAVAILABLE";
    TicketEscalationErrorCode[TicketEscalationErrorCode["ESCALATION_TARGET_OUT_OF_BUSINESS_HOURS"] = -400101] = "ESCALATION_TARGET_OUT_OF_BUSINESS_HOURS";
})(TicketEscalationErrorCode || (TicketEscalationErrorCode = {}));
var ticketsRelativePath = '/tickets';
var savedRepliesRelativePath = '/savedReplies';
export var createTicketsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + ticketsRelativePath;
    var savedRepliesApiUrl = baseUrl + savedRepliesRelativePath;
    var api = {
        getTicket: function (id) {
            return http.get("".concat(apiUrl, "/").concat(id));
        },
        getExtendedTicket: function (id) {
            return http.get("".concat(apiUrl, "/").concat(id, "/admin"));
        },
        addTicketCallNote: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/notes"), dto);
        },
        updateTicketCallNote: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/notes/").concat(dto.noteId), { content: dto.content });
        },
        deleteTicketCallNote: function (dto) {
            return http.delete("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/notes/").concat(dto.noteId));
        },
        requestCallback: function (dto) {
            return http.post("".concat(apiUrl, "/callbackRequests"), dto);
        },
        requestCallbackOnBehalf: function (dto) {
            return http.post("".concat(apiUrl, "/callbackRequests/onBehalf"), dto);
        },
        cancelCallback: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/cancelCallback"), {});
        },
        transferCallToNumber: function (dto) {
            var requestDto = { toNumber: dto.toNumber, lineId: dto.lineId };
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.phoneCallId, "/transferToNumber"), requestDto);
        },
        getTransferHistory: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/transferHistory"));
        },
        getTicketByNumber: function (dto) {
            return http.get("".concat(apiUrl, "/byNumber/").concat(dto.ticketNumber, "/admin"));
        },
        searchAdmin: function (dto) {
            return http.post("".concat(apiUrl, "/search/admin"), dto);
        },
        searchAdminIncludeConversation: function (dto) {
            return http.post("".concat(apiUrl, "/search/admin/includeConversation"), dto);
        },
        syncCall: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/sync"), {});
        },
        transferTicket: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/transfer"), { targetUserId: dto.targetUserId });
        },
        replyTickets: function (dto) {
            return http.post("".concat(apiUrl, "/agentReplies"), dto);
        },
        replyTicketsNew: function (dto) {
            return http.post("".concat(apiUrl, "/agentReplies/new"), dto);
        },
        replyTicket: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.id, "/agentReply"), dto);
        },
        replyTicketHelpCenter: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.id, "/replies"), dto);
        },
        relationsTickets: function (dto) {
            return http.post("".concat(apiUrl, "/relations"), dto);
        },
        removeRelations: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.id, "/relations/remove"), { relatedArticleIds: dto.relatedArticleIds });
        },
        relationsTicket: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.id, "/relations"), dto);
        },
        setTicketsStatus: function (dto) {
            return http.post("".concat(apiUrl, "/setStatus"), dto);
        },
        setTicketStatus: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.id, "/status"), dto);
        },
        assignTickets: function (dto) {
            return http.post("".concat(apiUrl, "/assign"), dto);
        },
        setTicketsPriority: function (dto) {
            return http.post("".concat(apiUrl, "/setPriority"), dto);
        },
        markTicketsAsSpam: function (dto) {
            return http.post("".concat(apiUrl, "/markSpam"), dto);
        },
        markTicketsAsHam: function (dto) {
            return http.post("".concat(apiUrl, "/markHam"), dto);
        },
        deleteTickets: function (dto) {
            return http.post("".concat(apiUrl, "/delete"), dto);
        },
        updateTicketsLabels: function (dto) {
            return http.put("".concat(apiUrl, "/labels"), dto);
        },
        getSavedFilter: function (dto) {
            var id = dto.id;
            return http.get("".concat(baseUrl, "/savedFilters/").concat(id));
        },
        getSavedFilters: function (dto) {
            var locale = dto.locale, context = dto.context;
            var maybeContext = context ? "&context=".concat(context) : '';
            return http.get("".concat(baseUrl, "/savedFilters?locale=").concat(locale).concat(maybeContext));
        },
        getSavedFiltersNew: function (dto) {
            return http.post("".concat(baseUrl, "/savedFilters/new"), dto);
        },
        getSavedFiltersPerLocale: function (dto) {
            var locales = dto.locales, context = dto.context;
            return http.get("".concat(baseUrl, "/savedFilters/perLocale?locales=").concat(locales, "&context=").concat(context));
        },
        updateSavedFilter: function (dto) {
            var id = dto.id;
            return http.put("".concat(baseUrl, "/savedFilters/").concat(id), dto);
        },
        updateSavedFilterNew: function (dto) {
            var id = dto.id;
            return http.put("".concat(baseUrl, "/savedFilters/").concat(id, "/new"), dto);
        },
        deleteSavedFilter: function (dto) {
            var id = dto.id;
            return http.delete("".concat(baseUrl, "/savedFilters/").concat(id));
        },
        addSavedFilter: function (dto) {
            return http.post("".concat(baseUrl, "/savedFilters"), dto);
        },
        renameSavedFilter: function (dto) {
            var id = dto.id;
            return http.put("".concat(baseUrl, "/savedFilters/").concat(id, "/rename"), dto);
        },
        getPresenceInfoList: function (dto) {
            var dtoWithTtl = __assign(__assign({}, dto), { maxAge: PRESENCE_TTL });
            return http.post("".concat(apiUrl, "/presence"), dtoWithTtl);
        },
        addTicket: function (dto) {
            return http.post("".concat(apiUrl, "/outbound"), dto);
        },
        addTicketOnBehalf: function (dto) {
            return http.post("".concat(apiUrl, "/onBehalf"), dto);
        },
        getCustomFields: function () {
            return http.get("".concat(baseUrl, "/fields"));
        },
        updateTicketCustomFields: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.id, "/fields"), __assign(__assign({}, dto), { id: undefined }));
        },
        getFiltersTicketsCount: function (dto) {
            return http.post("".concat(apiUrl, "/filtersCounts"), dto);
        },
        getFiltersTicketsCountNew: function (dto) {
            return http.post("".concat(apiUrl, "/filtersCounts/new"), dto);
        },
        getTicketTimeline: function (dto) { return __awaiter(void 0, void 0, void 0, function () {
            var timeline, ticket, normalizedTicket, normalizedTimeline;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http.get("".concat(apiUrl, "/").concat(dto.ticketId, "/timeline"))];
                    case 1:
                        timeline = _a.sent();
                        ticket = timeline.ticket;
                        normalizedTicket = __assign(__assign({}, ticket), { labels: ticket.labels || [], priority: ticket.priority || TicketPriority.NORMAL });
                        normalizedTimeline = __assign(__assign({}, timeline), { ticket: normalizedTicket });
                        return [2 /*return*/, normalizedTimeline];
                }
            });
        }); },
        getUserTicketTimeline: function (dto) { return __awaiter(void 0, void 0, void 0, function () {
            var timeline, ticket, normalizedTicket, normalizedTimeline;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http.get("".concat(apiUrl, "/").concat(dto.ticketId, "/userTimeline"))];
                    case 1:
                        timeline = _a.sent();
                        ticket = timeline.ticket;
                        normalizedTicket = __assign(__assign({}, ticket), { labels: ticket.labels || [], priority: ticket.priority || TicketPriority.NORMAL });
                        normalizedTimeline = __assign(__assign({}, timeline), { ticket: normalizedTicket });
                        return [2 /*return*/, normalizedTimeline];
                }
            });
        }); },
        addTimelineEvent: function (dto) { return __awaiter(void 0, void 0, void 0, function () {
            var customText, ticketId;
            return __generator(this, function (_a) {
                customText = dto.customText, ticketId = dto.ticketId;
                return [2 /*return*/, http.post("".concat(apiUrl, "/").concat(ticketId, "/timeline"), { customText: customText })];
            });
        }); },
        applyMacro: function (dto) {
            var ticketId = dto.ticketId, macroId = dto.macroId;
            return http.post("".concat(apiUrl, "/").concat(ticketId, "/macros/").concat(macroId, "/execute"), { macroId: macroId });
        },
        customFields: createMultiLingualCustomFieldsApi("".concat(apiUrl), http, ItemType.TICKET),
        multilevelFields: createMultilevelCustomFieldsApi("".concat(apiUrl), http, ItemType.TICKET),
        getSavedReplies: function (dto) {
            return http.post("".concat(savedRepliesApiUrl, "/search"), dto);
        },
        getSavedReply: function (dto) {
            return http.get("".concat(savedRepliesApiUrl, "/").concat(dto.id, "/admin?locale=").concat(dto.locale));
        },
        isTicketFollowed: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.id, "/follow"));
        },
        follow: function (id) {
            return http.post("".concat(apiUrl, "/").concat(id, "/follow"), {});
        },
        unfollow: function (id) {
            return http.delete("".concat(apiUrl, "/").concat(id, "/follow"));
        },
        deleteCallRecording: function (dto) {
            return http.delete("".concat(apiUrl, "/").concat(dto.ticketId, "/calls/").concat(dto.callId, "/deleteRecording"));
        },
        updateReplyContent: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.id, "/replies/").concat(dto.replyId), dto);
        },
        setLocale: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.ticketId, "/locale"), { newLocale: dto.newLocale });
        },
        updateTicketContent: function (dto) {
            var id = dto.id, content = dto.content, subject = dto.subject;
            return http.put("".concat(apiUrl, "/").concat(id), { content: content, subject: subject });
        },
        relatedArticles: function (ticketId) {
            return http.get("".concat(apiUrl, "/").concat(ticketId, "/relations/admin"));
        },
        session: {
            startForAgent: function (dto) { return http.post("".concat(apiUrl, "/").concat(dto.id, "/startHandling"), dto); },
            endForAgent: function (dto) { return http.post("".concat(apiUrl, "/").concat(dto.id, "/endHandling/new"), dto); },
            endForAll: function (dto) { return http.post("".concat(apiUrl, "/").concat(dto.id, "/endAllHandling/new"), dto); },
            bulkEndForAgent: function (dto) { return http.post("".concat(apiUrl, "/endHandling/bulk"), dto); },
            bulkEndForAll: function (dto) { return http.post("".concat(apiUrl, "/endAllHandling/bulk"), dto); },
        },
        reportTicketPresenceStatus: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.id, "/presence"), dto);
        },
        updateTicketCompany: function (dto) {
            return http.put("".concat(apiUrl, "/company"), { ids: [dto.id], companyId: dto.companyId });
        },
        updateTicketAndAgentCompany: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.id, "/setCompanyOnTicketAndUser"), { companyId: dto.companyId });
        },
        snoozeTicket: function (dto) { return http.post("".concat(apiUrl, "/snooze"), dto); },
        unsnoozeTicket: function (dto) { return http.post("".concat(apiUrl, "/unSnooze"), dto); },
        mergeTickets: function (dto) {
            return http.post("".concat(apiUrl, "/merge"), dto);
        },
        uploadFile: function (dto, progressCallback) {
            return createFilesApi("".concat(apiUrl, "/").concat(dto.ticketId, "/files"), http).uploadFileNew(dto, progressCallback);
        },
        checkFileStatus: function (dto) {
            return createFilesApi("".concat(apiUrl, "/").concat(dto.ticketId, "/files"), http).checkFileStatus(dto);
        },
        addAgentInternalNote: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.id, "/agentInternalNote"), dto);
        },
        addAgentInternalNotes: function (dto) {
            return http.post("".concat(apiUrl, "/agentInternalNotes"), dto);
        },
        getReplyRawEmail: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.ticketId, "/replies/").concat(dto.replyId, "/rawEmail"));
        },
        updateTicketBrand: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.ticketId, "/brand"), { brandId: dto.brandId });
        },
        getTicketAutoRoutingAssignments: function (ticketId) {
            return http.get("".concat(apiUrl, "/").concat(ticketId, "/autoRouting/assignments"));
        },
        transferChat: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/chatTransfer"), dto);
        },
        transferChatNew: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.ticketId, "/chatTransfer/new"), dto);
        },
        updateCCRecipients: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.id, "/ccRecipients"), dto);
        },
        getTicketsOfUser: function (dto) {
            return http.post("".concat(apiUrl, "/my"), {
                locale: dto.locale,
                page: dto.page,
                pageSize: dto.pageSize,
                channelFilters: dto.channelFilters
            });
        },
        escalateTicket: function (dto) { return http.post("".concat(apiUrl, "/").concat(dto.id, "/escalate"), dto); },
        getTicketEscalations: function (dto) { return http.get("".concat(apiUrl, "/").concat(dto.id, "/escalations")); },
        getExternalProvidersEscalations: function () { return http.get("".concat(apiUrl, "/externalProvidersEscalations")); },
        createTicketHelpcenter: function (dto) { return http.post(apiUrl, dto); },
        updateSkills: function (dto) { return http.put("".concat(apiUrl, "/").concat(dto.id, "/skills"), dto); },
        updateTicketsSkills: function (dto) { return http.post("".concat(apiUrl, "/skills"), dto); },
        getRoutingTargetGroup: function (dto) { return http.post("".concat(apiUrl, "/routingTargetGroup"), dto); },
        summary: {
            chat: function (dto) { return http.post("".concat(apiUrl, "/").concat(dto.id, "/chatSummary"), {}); },
        },
        checkAvailability: function (dto, includeMetadata) { return http.post("".concat(apiUrl, "/checkAvailability"), dto, undefined, undefined, includeMetadata); },
        getTicketInteractions: function (dto) { return http.post("".concat(apiUrl, "/interactions"), dto); },
    };
    return api;
};
//# sourceMappingURL=index.js.map